import { useEffect, useState } from "react";
import { CalendarX } from "lucide-react";
import { api, errMsg } from "@/lib/api";

function DayChip({ d, active, onClick }) {
  const [y, m, day] = d.date.split("-").map(Number);
  const dt = new Date(y, m - 1, day);
  return (
    <button type="button" onClick={onClick} data-testid={`slot-day-${d.date}`}
      className={`slot-btn shrink-0 w-[74px] py-2.5 text-center ${active ? "active" : ""}`}>
      <div className="text-[10px] uppercase tracking-widest opacity-80">{dt.toLocaleDateString("it-IT", { weekday: "short" })}</div>
      <div className="text-xl font-bold leading-tight">{day}</div>
      <div className="text-[10px] uppercase opacity-80">{dt.toLocaleDateString("it-IT", { month: "short" })}</div>
    </button>
  );
}

export default function SlotPicker({ value, onChange, reloadKey }) {
  const [days, setDays] = useState(null);
  const [error, setError] = useState("");
  const [day, setDay] = useState(null);

  useEffect(() => {
    api.get("/slots")
      .then(({ data }) => {
        setDays(data);
        setDay((cur) => (data.find((d) => d.date === cur) ? cur : data[0]?.date || null));
      })
      .catch((e) => setError(errMsg(e)));
  }, [reloadKey]);

  if (error) return <div className="text-sm text-red-400">{error}</div>;
  if (!days) return <div className="text-sm text-slate-500" data-testid="slots-loading">Caricamento disponibilità…</div>;
  if (!days.length)
    return (
      <div className="surface-2 p-5 flex items-center gap-3 text-slate-300" data-testid="no-slots-message">
        <CalendarX className="text-[#E50914]" /> Nessuno slot disponibile al momento. Riprova più tardi.
      </div>
    );
  const current = days.find((d) => d.date === day);
  return (
    <div data-testid="slot-picker">
      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-2">
        {days.map((d) => (
          <DayChip key={d.date} d={d} active={d.date === day} onClick={() => setDay(d.date)} />
        ))}
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-2 mt-3">
        {current?.times.map((t) => {
          const active = value?.date === day && value?.time === t;
          return (
            <button key={t} type="button" onClick={() => onChange({ date: day, time: t })}
              data-testid={`slot-time-${t.replace(":", "")}`}
              className={`slot-btn py-2.5 text-sm font-bold ${active ? "active" : ""}`}>
              {t}
            </button>
          );
        })}
      </div>
    </div>
  );
}
